import React from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";
import "./noResultsIcon.sass";

export interface INoResultsIconProps {
  titleText: string;
  bodyText?: string;
  iconSource?: IconSource;
}

const NoResultsIcon: React.FC<INoResultsIconProps> = ({
  titleText,
  bodyText,
  iconSource = IconSource.noSearchResults
}) => {
  return (
    <div className="no-results-icon">
      <Icon source={iconSource} />
      <p>{titleText}</p>
      {bodyText && <p>'{bodyText}'</p>}
    </div>
  );
};

export default NoResultsIcon;
